// The two lines every picker shows (owner, 2026-10-16): a partner with its
// trades beneath, and a trade/discipline with its partners beneath. See
// ./partnerTrades for where the words come from.
import React from "react";
import { usePartnerTrades } from "./partnerTrades";

const SUB = { display: "block", fontSize: 11, color: "#8c8c8c", lineHeight: "15px", whiteSpace: "normal" };

/** "BES" / "Electrical, Telecom, Power" */
export function PartnerWithTrades({ name, trades, suffix = null }) {
  return (
    <span style={{ display: "inline-block", lineHeight: "18px" }}>
      <span>{name}{suffix}</span>
      {trades && trades.length ? <span style={SUB}>{trades.join(", ")}</span> : null}
    </span>
  );
}

/** "Electrical" / "BES, DP Electric, Inc" */
export function TradeWithPartners({ label, partners }) {
  return (
    <span style={{ display: "inline-block", lineHeight: "18px" }}>
      <span>{label}</span>
      {partners && partners.length ? <span style={SUB}>{partners.join(", ")}</span> : null}
    </span>
  );
}

/**
 * A discipline on a row that belongs to a project - the partners read from
 * that project's roster (cached per project, so a table of rows asks once
 * per project).
 */
export function DisciplineWithPartners({ projectId, discipline }) {
  const ix = usePartnerTrades(projectId);
  const d = discipline && typeof discipline === "object" ? discipline : { key: discipline, value: discipline };
  const label = d.key || d.value || "";
  if (!label) return null;
  return <TradeWithPartners label={label} partners={ix.partnersOf(d.key, d.value)} />;
}
